"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaginationResultsDto = void 0;
const class_validator_1 = require("class-validator");
const pagination_details_dto_1 = require("./pagination-details.dto");
const mappable_base_1 = require("../../mappable.base");
/**
 * @class PaginationResultsDto
 * @description
 * contains pagination options and query results
 */
class PaginationResultsDto extends mappable_base_1.MappableBase {
    constructor(options) {
        super();
        if (!options)
            return;
        this.results = options.results;
        this.options = options.options;
    }
    getFields() {
        return ['results', 'options'];
    }
    results;
    options;
}
exports.PaginationResultsDto = PaginationResultsDto;
__decorate([
    (0, class_validator_1.IsArray)(),
    __metadata("design:type", Array)
], PaginationResultsDto.prototype, "results", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    __metadata("design:type", pagination_details_dto_1.PaginationDetailsDto)
], PaginationResultsDto.prototype, "options", void 0);
